import * as React from 'react'
import { BaseFilterState, SingleFilterState } from '../helpers/FilterStates';
import FilterNumberInput from '../helpers/FilterNumberInput';
import EditableFilterComponent from '../helpers/EditableFilterComponent';
import isMobile from 'is-mobile';
import { FilterableProperty } from '../helpers/FilterableProperty';


type Props = {
    onValueChange: (newValue: BaseFilterState) => void,
}

export const nodeChannelCountProperty = new FilterableProperty('node', 'channelCount');

const NodeChannelCountFilter: React.FC<Props> = ({ onValueChange}: Props) => {
    const initialValue = 1;
    const [value, setValue] = React.useState<number>(initialValue);
    const [tempValue, setTempValue] = React.useState<number>(initialValue);
    const [isEdit, setIsEdit] = React.useState<boolean>(false);


    function commitChange(newValue: number) {
        setTempValue(newValue);
        setValue(newValue);
        onValueChange(new SingleFilterState(nodeChannelCountProperty, 'gte', newValue))
    }

    function changeEditing(newVal: boolean) {
        if (newVal) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
            const valueChanged = value !== tempValue
            if (valueChanged) {
                commitChange(tempValue);
            }
        }
    }

    React.useEffect(() => {
        if (isMobile()) {
            // This is coordinated with GDataPrunedProvider that does the same.
            // Cut down graph so it is more usable on mobile
            commitChange(5);
        }
    }, []);

    return (
        <EditableFilterComponent isEdit={isEdit} onChange={newVal => changeEditing(newVal)}>
            Number of channels: <FilterNumberInput isEdit={isEdit} value={tempValue} onValueChange={(newValue) => {
                if (newValue <= 0) {
                    setTempValue(1);
                } else {
                    setTempValue(newValue);
                }
            }}
                onEnter={() => changeEditing(false)} 
                suffix=""
                prefix=">"
                autoFocus={true}
                />
        </EditableFilterComponent>
    );
}

export default NodeChannelCountFilter;



